import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative w-full rounded-sm shadow-sm" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "absolute w-full origin-top-right left-0 mt-1 rounded-md bg-white dark:bg-gray-bluer-800 border-2 border-transparent dark:border-gray-bluer-500 shadow-lg z-10"
}
const _hoisted_7 = {
  key: 0,
  class: "px-8 py-4"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-normal block truncate" }, "Custom Link", -1)
const _hoisted_11 = {
  role: "option",
  class: "py-2.5 px-3"
}
const _hoisted_12 = { class: "flex items-center whitespace-normal space-x-2.5 mt-2 text-gray-bluer-300 dark:text-gray-bluer-50 rounded border-2 border-gray-blue-300 bg-gray-blue-50 dark:bg-gray-bluer-700 dark:border-gray-bluer-500 p-3" }
const _hoisted_13 = { class: "flex-shrink-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "leading-tight text-sm" }, "These are used when a form needs a hidden value populated based on a content section you are in.", -1)
const _hoisted_15 = {
  role: "option",
  class: "pb-2.5 px-3 flex justify-end"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Done ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-normal block truncate" }, "Go Back", -1)
const _hoisted_18 = {
  role: "option",
  class: "flex items-center border-b border-gray-blue-400 dark:border-gray-bluer-500 select-none relative"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["innerHTML"]

import {toRefs, ref, onMounted, onUnmounted, computed, watch, nextTick} from "vue";
import {useFieldHook} from "@greywind/ui";
import {useStore} from "vuex";
import {userHook} from "@/hooks/user"
import {api} from "@greywind/common";
import {cloneDeep, isEqual} from "lodash";
import {FieldDynamic} from "../field-dynamic";

import {
    AppFieldErrorIcon,
    AppFieldDefault,
    AppLoader,
    AppButton
} from "@greywind/ui";


export default /*#__PURE__*/_defineComponent({
  props: {
        field: {
            type: Object,
            required: true
        },
        error: [String, Boolean],
        inputClass: String,
        modelValue: {}
    },
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

const store = useStore();
const {activeEnvironment} = userHook( store );


const {field, error, inputClass, modelValue} = toRefs( props );



const {formField, value, mountEvent, unmountEvent, setInitialValue, fill, handleChange, isReadonly} = useFieldHook(
    {
        emit, field, error, inputClass, modelValue
    }, null, false, () => setActive() );

const locked = computed( () => !!( value.value && ( value.value.startsWith( 'resource:' ) || value.value.startsWith( 'form:' ) ) ) )

const defaultAttributes = computed( () => (
    {}
) );

const extraAttributes = computed( () => (
    {
        ...( defaultAttributes.value || {} ),
        ...( field.value.extraAttributes || {} )
    }
) );

const searchableItems = computed( () => {
    if ( searchQuery.value !== null && searchQuery.value !== '' ) {
        return items.value.filter( item => item.label.split( '<span ' )[ 0 ].toLowerCase().indexOf( searchQuery.value.toLowerCase() ) > -1 )
    }

    return items.value;
} );

const inputField = ref( null );
const loading = ref( false );
const show = ref( false );
const activeLink = ref( null );
const activeItem = ref(
    {
        label: null,
        value: null
    }
);
const fieldsItem = ref( null );
const links = ref( [] );
const items = ref( [] );
const fields = ref( [] );
const searchQuery = ref( null );

onMounted( async (): Promise<void> => {
    mountEvent();

    if ( formField.value && field.value.extraAttributes && field.value.extraAttributes.focus ) inputField.value.focus();

    await setActive();

    watch( () => activeLink.value, v => v && setLink() );
    watch( () => activeItem.value, v => {
        value.value = cloneDeep( v.value );
        emit( 'update:modelValue', cloneDeep( v.value ) );
    } );
} );

onUnmounted( (): void => unmountEvent() );

const setItem = ( item: any ): void => {
    activeItem.value = item;
    toggle();
}

const addForm = (): void => {
    fields.value.forEach( f => {
        if ( f.value ) {
            fieldsItem.value.value = `${fieldsItem.value.value}|${f.dbKey}:${f.value}`;
        }
    } );

    activeItem.value = cloneDeep( fieldsItem.value );
    fieldsItem.value = null;
    fields.value = [];
    toggle();
}

const toggleFormFields = ( item: any ): void => {
    fieldsItem.value = cloneDeep( item );
    fields.value = activeLink.value.fields || [];
}

const setActive = async (): Promise<void> => {
    if ( value.value && ( value.value.startsWith( 'resource:' ) || value.value.startsWith( 'form:' ) ) ) {
        try {
            const {data}: { data: any } = await api.fetch( 'get', 'denfield-app-user/denfield-package-navigation/links/find', {value: value.value}, activeEnvironment.value.meta.api.url );
            if ( data ) {
                activeItem.value.label = data;
                activeItem.value.value = value.value;
            }
        } catch ( e ) {
            value.value = '';
        }
    }
}

const clear = (): void => {
    // set activeLink.value
    setItem( {
                 label: null,
                 value: null
             } );

    links.value = [];
    items.value = [];
    value.value = '';
    show.value = false;
}

const clearSearch = (): void => {
    searchQuery.value = null;
}

const goCustom = (): void => {
    clear();

    nextTick( () => inputField.value.focus() );
}

const setLink = async (): Promise<void> => {
    loading.value = true;

    const {data}: { data: any } = await api.fetch( 'get', 'denfield-app-user/denfield-package-navigation/links/show', {model: activeLink.value.model}, activeEnvironment.value.meta.api.url );

    items.value = data || [];

    loading.value = false;
}

const toggle = async (): Promise<void> => {
    show.value = !show.value;

    if ( show.value && links.value && !links.value.length ) {
        loading.value = true;
        const {data}: { data: any } = await api.fetch( 'get', 'denfield-app-user/denfield-package-navigation/links', {}, activeEnvironment.value.meta.api.url );

        links.value = data;

        loading.value = false;
    } else if ( !show.value ) {
        links.value = [];
        items.value = [];
        activeLink.value = null;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!

  return (_openBlock(), _createBlock(_unref(AppFieldDefault), {
    field: _unref(field),
    error: _unref(error)
  }, {
    field: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _mergeProps({
          style: {"min-height":"2.5rem"},
          class: ["relative block w-full px-3 py-2 rounded-sm shadow-sm focus:outline-none sm:text-sm bg-white dark:bg-gray-bluer-800 text-gray-bluer-200 dark:text-gray-blue-500 border-2 border-transparent", [
                            `text-${_unref(field).textAlign || 'left'}`,
                            _unref(inputClass),
                            _unref(error)
                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                                : 'border-gray-blue-300 dark:border-gray-bluer-500 focus:ring-theme focus:border-theme placeholder-gray-bluer-50 dark:text-gray-blue-700'
                        ]],
          id: _unref(field).attribute
        }, _unref(extraAttributes), {
          ref_key: "formField",
          ref: formField,
          onClick: toggle
        }), [
          (!_unref(locked))
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "text",
                onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleChange) && _unref(handleChange)(...args))),
                value: _unref(value),
                ref_key: "inputField",
                ref: inputField,
                class: _normalizeClass(["absolute inset-0 w-full border-none outline-none px-3 py-2 border-2 border-transparent rounded-sm shadow-sm appearance-none focus:outline-none sm:text-sm bg-white dark:bg-gray-bluer-800 text-gray-bluer-200 dark:text-gray-blue-500", [
                            `text-${_unref(field).textAlign || 'left'}`,
                            _unref(inputClass),
                            _unref(error)
                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                                : 'border-gray-blue-300 dark:border-gray-bluer-500 focus:ring-theme focus:border-theme placeholder-gray-bluer-50 dark:text-gray-blue-700'
                        ]])
              }, null, 42, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                innerHTML: activeItem.value.label || _unref(value)
              }, null, 8, _hoisted_4)),
          _createElementVNode("span", {
            class: "absolute right-2.5 top-2.5 hover:text-theme transition duration-150 ease-in-out cursor-pointer",
            onClick: _withModifiers(clear, ["stop"])
          }, [
            _createVNode(_component_x_icon, {
              icon: "fontawesome.xmark",
              class: "w-4 h-4"
            })
          ], 8, _hoisted_5)
        ], 16, _hoisted_2),
        _createVNode(_Transition, {
          "enter-active-class": "",
          "enter-class": "",
          "enter-to-class": "",
          "leave-active-class": "transition ease-in duration-100",
          "leave-to-class": "opacity-100",
          "leave-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            (show.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("ul", {
                    tabindex: "-1",
                    role: "listbox",
                    "aria-labelledby": "listbox-label",
                    class: _normalizeClass(["rounded-md text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", { 'overflow-auto max-h-60': !(activeLink.value && fields.value && fields.value.length) }])
                  }, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                          _createVNode(_unref(AppLoader), {
                            class: "text-theme",
                            "background-colour": "bg-white bg-opacity-100 dark:bg-gray-bluer-800",
                            width: "40",
                            height: "40",
                            positioning: "relative"
                          })
                        ]))
                      : (!activeLink.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (item, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: `option_${i}`,
                                role: "option",
                                class: _normalizeClass(["flex items-center cursor-pointer space-x-3 group text-gray-bluer-300 dark:text-gray-blue-500 cursor-default hover:bg-theme hover:text-white select-none relative py-2 pl-3 pr-9", {
                                        'rounded-t-md': i === 0,
                                    }]),
                                onClick: ($event: any) => {activeLink.value = item; clearSearch();}
                              }, [
                                (item.icon)
                                  ? (_openBlock(), _createBlock(_component_x_icon, {
                                      key: 0,
                                      icon: item.icon,
                                      class: "w-4 h-4"
                                    }, null, 8, ["icon"]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", {
                                  class: "font-normal block truncate",
                                  innerHTML: item.name
                                }, null, 8, _hoisted_9)
                              ], 10, _hoisted_8))
                            }), 128)),
                            _createElementVNode("li", {
                              role: "option",
                              class: "flex items-center rounded-b-md cursor-pointer space-x-3 group text-gray-bluer-300 dark:text-gray-blue-500 cursor-default hover:bg-theme hover:text-white select-none relative py-2 pl-3 pr-9",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => {goCustom; clearSearch();})
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.link",
                                class: "w-4 h-4"
                              }),
                              _hoisted_10
                            ])
                          ], 64))
                        : (fields.value && fields.value.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("li", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_x_icon, {
                                      icon: "fontawesome.circle-info",
                                      class: "w-5 h-5"
                                    })
                                  ]),
                                  _hoisted_14
                                ])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (field, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  role: "option",
                                  key: `option_field_${i}`,
                                  class: "py-2.5"
                                }, [
                                  _createVNode(_unref(FieldDynamic), {
                                    field: field,
                                    modelValue: fields.value[i].value,
                                    "onUpdate:modelValue": ($event: any) => ((fields.value[i].value) = $event)
                                  }, null, 8, ["field", "modelValue", "onUpdate:modelValue"])
                                ]))
                              }), 128)),
                              _createElementVNode("li", _hoisted_15, [
                                _createVNode(_unref(AppButton), {
                                  size: "small",
                                  theme: "theme",
                                  onClick: addForm
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_16
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createElementVNode("li", {
                                role: "option",
                                class: _normalizeClass(["flex items-center rounded-t-md cursor-pointer space-x-3 group border-b border-gray-blue-400 bg-gray-blue-50 dark:bg-gray-bluer-700 dark:border-gray-bluer-500 text-gray-bluer-300 dark:text-gray-blue-500 cursor-default hover:bg-theme hover:text-white select-none relative py-2 pl-3 pr-9", {
                                        'rounded-b-md': items.value && items.value.length === 0
                                    }]),
                                onClick: _cache[2] || (_cache[2] = ($event: any) => {activeLink.value = null; items.value = []})
                              }, [
                                _createVNode(_component_x_icon, {
                                  icon: "fontawesome.arrow-left",
                                  class: "w-4 h-4"
                                }),
                                _hoisted_17
                              ], 2),
                              _createElementVNode("li", _hoisted_18, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery).value = $event)),
                                  placeholder: "Search...",
                                  ref: "inputSearchField",
                                  class: "w-full text-gray-bluer-300 dark:text-gray-blue-500 border-none bg-gray-blue-50 dark:bg-gray-bluer-700"
                                }, null, 512), [
                                  [_vModelText, searchQuery.value]
                                ]),
                                _createElementVNode("span", {
                                  class: "absolute right-2.5 top-2.5 hover:text-theme transition duration-150 ease-in-out cursor-pointer",
                                  onClick: _withModifiers(clearSearch, ["stop"])
                                }, [
                                  _createVNode(_component_x_icon, {
                                    icon: "fontawesome.xmark",
                                    class: "w-4 h-4"
                                  })
                                ], 8, _hoisted_19)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchableItems), (item, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: `option_child_${ i }`,
                                  role: "option",
                                  class: _normalizeClass(["flex items-center cursor-pointer space-x-3 group text-gray-bluer-300 dark:text-gray-blue-500 cursor-default hover:bg-theme hover:text-white select-none relative py-2 pl-3 pr-9", {
                                        'rounded-b-md': i === ( _unref(searchableItems).length - 1 )
                                    }]),
                                  onClick: ($event: any) => (activeLink.value.fields && activeLink.value.fields.length ? toggleFormFields( item ) : setItem( item ))
                                }, [
                                  _createElementVNode("span", {
                                    class: "font-normal block truncate",
                                    innerHTML: item.label
                                  }, null, 8, _hoisted_21)
                                ], 10, _hoisted_20))
                              }), 128))
                            ], 64))
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_unref(error))
          ? (_openBlock(), _createBlock(_unref(AppFieldErrorIcon), { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["field", "error"]))
}
}

})